import { selectCommunicationData } from "../../store";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { Vspace } from '../../components/styled/Separators.style'
import PageContainerCmp from "../PageContainerCmp";
import { saveCommunicationAct } from "../../store/communication-data/actions";
import { CommunicationType, EventCommType, EventValueEnum } from "../../types/communication/communicationDataType";
import { LINEAR_BASE_ROUTE, LINEAR_PATHS } from "../../routes/linearRouteConstants";
import { LQuestionText } from "../../components/styled/Text.style";
import { LNextButton } from "../../components/styled/Button.style";
import { LButtonContainer, Section, LVerticalSection } from "../../components/styled/Containers.style";
import LinearFooterCmp from "../../components/footer/LinearFooter";
import { composeUrl } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { isExpired48h } from "../../utils/time.utils";

const QuestionAgreementPageLinear = () => {
    const dispatch = useAppDispatch();
    const communicationData = useAppSelector(selectCommunicationData)
    const navigate = useNavigate();
    const { communication } = communicationData
    const { token } = communication;

    useEffect(() => {
        /* istanbul ignore next */
        if (isExpired48h(communication?.creation_date)) {
            let nextPath = composeUrl(token, LINEAR_PATHS.SIGNATURE_PROPOSAL_PAGE, LINEAR_BASE_ROUTE)
            navigate(nextPath)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const goToNextStepHandler = (value: boolean) => {
        /* istanbul ignore next */
        const _pathname = composeUrl(token, LINEAR_PATHS.SIGNATURE_PROPOSAL_PAGE, LINEAR_BASE_ROUTE)
        /* istanbul ignore next */
        let newEvent = new EventCommType({ value: EventValueEnum.LINEAR_CONFIRM_AGREEMENT_WITH_CTP })
        if (value === false) {
            newEvent = new EventCommType({ value: EventValueEnum.LINEAR_REFUSE_AGREEMENT_WITH_CTP })
        }
        const data = new CommunicationType({
            ...communication,
            linearControparteInfo: {
                ...communication.linearControparteInfo,
                agreeWithCtp: value
            }
        })
        /* istanbul ignore next */
        dispatch(saveCommunicationAct({
            events: [newEvent],
            data,
            callback: () => {
                navigate(_pathname)
            }
        })
        )
    }

    return (
        <>

            <PageContainerCmp
                routePath={LINEAR_PATHS.QUESTION_AGREEMENT_PAGE}
                removeNextBtn
                eventsOnLoad={[EventValueEnum.LINEAR_AGREEMENT_QUESTION_SHOW]}
            >

                <Section linear={true}>
                    <LVerticalSection>
                        <LQuestionText>Sei d'accordo con l'altro conducente sulla dinamica dell'incidente e hai il suo numero di cellulare?</LQuestionText>

                        <Vspace qty={4}></Vspace>

                        <LButtonContainer>
                            <LNextButton onClick={() => goToNextStepHandler(true)}>Sì</LNextButton>
                            <LNextButton onClick={() => goToNextStepHandler(false)}>NO</LNextButton>
                        </LButtonContainer>

                    </LVerticalSection>

                </Section>

                <LinearFooterCmp />

            </PageContainerCmp>
        </>

    )
}

export default QuestionAgreementPageLinear